import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { specificSubcategoryType, SpecificSubcategory } from '../../types/slices/specificSubcategoryType'

const initialState: specificSubcategoryType =
{
    status: ApiStatus.FETCHED,
    specificSubcategories: [],
    specificSubcategorySelected: {} as SpecificSubcategory,
    errorMessage: undefined,
    action: ''
}

const specificSubcategorySlice = createSlice({
    name: 'specificSubcategorySlice',
    initialState,
    reducers: {
        onFetchSpecificSubcategories (state, { payload }: { payload: SpecificSubcategory[]}) {
            state.status = ApiStatus.FETCHED
            state.specificSubcategories = payload
            state.errorMessage = undefined
        },
        onSetSelectedSpecificSubcategory (state, { payload }: { payload: SpecificSubcategory }) {
            state.specificSubcategorySelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSpecificSubcategoryState = (state: RootState) => state.specificSubcategorySlice
export default specificSubcategorySlice.reducer
export const {
    onFetchSpecificSubcategories,
    onSetSelectedSpecificSubcategory,
    changeStatus,
    setAction,
} = specificSubcategorySlice.actions
